import { Component, input } from '@angular/core';

@Component({
  selector: 'ui-page-header',
  standalone: true,
  template: `
    <div class="page-header">
      <div>
        <h1>{{ title() }}</h1>
        @if (subtitle()) {
          <p class="subtitle">{{ subtitle() }}</p>
        }
      </div>
      <div class="actions">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: [`
    .page-header { 
      display: flex; 
      justify-content: space-between; 
      align-items: center; 
    }
    .page-header h1 { 
      font-size: 1.75rem; 
      font-weight: 700; 
      color: var(--text-primary); 
      margin: 0; 
    }
    .subtitle { 
      color: var(--text-secondary); 
      margin: 0.25rem 0 0; 
      font-size: 0.9rem; 
    }
  `]
})
export class PageHeaderComponent {
  title = input.required<string>();
  subtitle = input<string>('');
}
